import * as z from "zod/v4";
import { alias } from "../util/alias.ts";

const ARC_ALIASES: Record<string, string> = {
  // Canonical (identity, for case-insensitive matching)
  grow: "grow",
  collapse: "collapse",
  transform: "transform",
  hold: "hold",
  // Alias from describe text
  discipline: "hold",
};

export const ArcSchema = z
  .enum(["grow", "collapse", "transform", "hold"])
  .describe(
    `The arc or directionality of the force.
- Grow means a positive feedback loop or exponential growth.
- Collapse means driving toward a catastrophic crash.
- Discipline means things are held in place by concerted effort or force
- Transform means a profound change in direction, rules, goals, constraints.`,
  );

export type Arc = z.infer<typeof ArcSchema>;

export const CoerceArcSchema = z.preprocess(alias(ARC_ALIASES), ArcSchema);

export const into = (value: unknown): Arc | undefined => {
  const { data, success } = CoerceArcSchema.safeParse(value);
  if (!success) return undefined;
  return data;
};

export const toDesc = (arc: Arc | undefined): string => {
  switch (arc) {
    case "grow":
      return "Grow";
    case "collapse":
      return "Collapse";
    case "transform":
      return "Transform";
    case "hold":
      return "Hold";
    default:
      return "";
  }
};
